export const voiceMessagesFieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    bgcolor: "var(--fx-surface-base, #FFFFFF)",
  },
};
